import React from 'react';
import { View, ViewProps, StyleSheet } from 'react-native';
import { colors, spacing } from '../theme';

export function Screen({ style, children, ...rest }: ViewProps) {
  return (
    <View style={[styles.container, style]} {...rest}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', padding: spacing.lg, backgroundColor: colors.sand },
});
